import { CardLabel } from "@/views/sms/section/common/types/featured";
import { ChoiceItem } from "@/common/types";
import { MaxLength } from "@/const/service/common/types";

export abstract class ServiceLanguage {
  abstract getGenreChoices(): ChoiceItem<string>[];
  abstract getCardLabels(): CardLabel[];
  abstract getCompletedTabLabels(): CardLabel[];
  abstract getContentCatchphraseMaxLength(): MaxLength;

  abstract getIpPromotionVideoTitleMaxLength(): number;
  abstract getIpPromotionVideoSubtitleMaxLength(): number;
  abstract getSpecialMatchingTitleMaxLength(): number;
  abstract getCustomLabelMaxLength(): number;
  abstract getCampaignPageTitleMaxLength(): number;
  abstract getCampaignPageModuleTitleMaxLength(): number;
  abstract getCampaignPageModuleTitleRowLength(): number;
  abstract getCampaignPageModuleSubTitleMaxLength(): number;
  abstract getCampaignPageModuleSubTitleRowLength(): number;
}
